import eventLogApi from '@/api/service/eventLog.service';
import asynchronousUtils from '@/utils/asynchronousUtils';
import { ActionContext, GetterTree, MutationTree } from 'vuex';
import { RootState } from '@/store';
import tokenExtractor from '@/utils/tokenExtractor';

interface EventLogState {
  lastEventId: number,
  timerManager: { run: Function, cancel: Function } | null,
}

const namespaced: boolean = true;

const state: EventLogState = {
  lastEventId: 0,
  timerManager: null,
};

const getters: GetterTree<EventLogState, RootState> = {};

const actions = {
  async fetchLastEventIdByToken({ commit }: ActionContext<EventLogState, RootState>, placeId: string) {
    const lastSocketEventId = await eventLogApi.getLastSocketEventId(placeId);

    commit('setLastEventId', lastSocketEventId);
  },
  async socketConnectError({ commit, dispatch, state }: ActionContext<EventLogState, RootState>) {
    if (state.timerManager === null && state.lastEventId !== 0) {
      const timerManager = asynchronousUtils.asyncRecursive(async () => {
        try {
          const socketEvents = await eventLogApi.getSocketEventsByLastSocketEventId(
            state.lastEventId,
            tokenExtractor.extract(),
          );

          return dispatch('handleNewEvents', socketEvents);
        } catch (e) {

        }
      }, 5000);

      commit('setTimerManager', timerManager);

      if (null !== state.timerManager) {
        timerManager.run();
      }
    }
  },
  async socketReconnect({ commit, dispatch, state }: ActionContext<EventLogState, RootState>) {
    if (state.timerManager !== null) {
      state.timerManager.cancel();

      commit('setTimerManager', null);
    }

    try {
      const socketEvents = await eventLogApi.getSocketEventsByLastSocketEventId(
        state.lastEventId,
        tokenExtractor.extract(),
      );

      return dispatch('handleNewEvents', socketEvents);
    } catch (e) {

    }
  },
  async handleNewEvents({ commit, dispatch }: ActionContext<EventLogState, RootState>, socketEvents: any[]) {
    if (socketEvents.length > 0) {
      dispatch('handleSocketEvents', socketEvents, { root: true });

      const lastEvent = socketEvents[socketEvents.length - 1];

      commit('setLastEventId', lastEvent.id);
    }
  }
};

const mutations: MutationTree<EventLogState> = {
  setTimerManager(state, timerManager: { run: Function, cancel: Function } | null) {
    state.timerManager = timerManager;
  },
  setLastEventId(state, lastEventId: number | null) {
    if (lastEventId !== null && lastEventId > state.lastEventId) {
      state.lastEventId = lastEventId;
    }
  },
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
